import { useContext } from 'react';
import { ResourceEditContext } from './ResourceEditContext';

const noContext = {
  queryParams: {},
  setAction: () => {
    console.trace('Must be wrapped within a ResourceEditProvider');
  },
};

export default function useResourceEditProvider() {
  const context = useContext(ResourceEditContext);
  if (!context) {
    return noContext;
  }

  return context;
}
